import { SelectTramiteComponent } from '@app/shared/select-tramite/select-tramite.component';
import { Component, OnInit, TemplateRef, ViewChild, OnDestroy } from '@angular/core';
import { isEmpty, find } from 'lodash';
import { Logger, GlobalInfoService, AuthenticationService } from '@app/core';
import {
  Const, ProcesoSecundario, TypeProcess
} from '@app/shared';
import { ConfigShowItems, Action } from '../process-automation/btn-trigger';
import { ManagementAutomationDataService } from './shared/management-automation.data.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ManageTitlesComponent } from './manage-titles/manage-titles.component';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';

const log = new Logger('ProcessAutomationComponent');

@Component({
  selector: 'iw-management-automation',
  templateUrl: './management-automation.component.html',
  styleUrls: ['./management-automation.component.scss'],
  providers: [ManagementAutomationDataService]
})
export class ManagementAutomationComponent implements OnInit, OnDestroy {
// Define cuando mostrar el el compornte time-control
tapComponetnView = false;

  // Define los tipos de permisos que tiene el usuario en sesión
  activateAction = {
    created: false,
    review: false,
    update: false,
    delete: false,
    duplicate: false,
    titles: false
  };

  // Define los tipos de permisos que tiene el usuario en sesión para control de tiempos
  activateTimeControl = {
    created: false,
    review: false,
    update: false,
    delete: false,
    duplicate: false,
    titles: false
  };
  // Lista de los procesos secundarios del sistema
  secondaryProcess: Array<ProcesoSecundario>;
  // Contiene el id del tramite secundario seleccionado
  idSecondaryProcessSelect: number;
  // Contiene el objeto del tramite secundario seleccionado
  secondaryProcessSelect: ProcesoSecundario;
  // Referencia de la modal
  modalRef: BsModalRef;
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // // Componente select-tramite
  @ViewChild('stcRef') stcRef: SelectTramiteComponent;
  // Compoennte de titulos
  @ViewChild('manageTitles') manageTitles: TemplateRef<any>;
  // Compoennte de anulación
  @ViewChild('manageAnnulation') manageAnnulation: TemplateRef<any>;

  constructor(
    private mads: ManagementAutomationDataService,
    private gis: GlobalInfoService,
    private as: AuthenticationService,
    private modalService: BsModalService,
    private toastr: ToastrService
  ) {
    // determina los permisos del usuario en sesion
    this.activateAction.created = this.as.confirmPermission(
      Const.types_permissions.administrationProcess,
      Const.types_action_permissions.created,
    );
    this.activateAction.review = this.as.confirmPermission(
      Const.types_permissions.administrationProcess,
      Const.types_action_permissions.review,
    );
    this.activateAction.update = this.as.confirmPermission(
      Const.types_permissions.administrationProcess,
      Const.types_action_permissions.update,
    );
    this.activateAction.delete = this.as.confirmPermission(
      Const.types_permissions.administrationProcess,
      Const.types_action_permissions.delete,
    );
    this.activateAction.duplicate = this.as.confirmPermission(
      Const.types_permissions.administrationProcess,
      Const.types_action_permissions.duplicate,
    );
    this.activateAction.titles = this.as.confirmPermission(
      Const.types_permissions.administrationProcess,
      Const.types_action_permissions.created,
    );
    if (this.activateAction.titles) {
      this.activateAction.titles = this.as.confirmPermission(
        Const.types_permissions.administrationProcess,
        Const.types_action_permissions.update,
      );
    }
     // determina los permisos del usuario en sesions para control de tiempos
     this.activateTimeControl.created = this.as.confirmPermission(
      Const.types_permissions.administracionEtapas,
      Const.types_action_permissions.created,
    );
    this.activateTimeControl.review = this.as.confirmPermission(
      Const.types_permissions.administracionEtapas,
      Const.types_action_permissions.review,
    );
    this.activateTimeControl.update = this.as.confirmPermission(
      Const.types_permissions.administracionEtapas,
      Const.types_action_permissions.update,
    );
    this.activateTimeControl.delete = this.as.confirmPermission(
      Const.types_permissions.administracionEtapas,
      Const.types_action_permissions.delete,
    );

    if(
      this.activateTimeControl.review ||
      this.activateTimeControl.created ||
      this.activateTimeControl. update ||
      this.activateTimeControl.delete
      ){
        this.tapComponetnView = true;
    }
    log.debug(this.activateAction);
  }

  ngOnInit() {
    // se setea el titulo de la vista actual
    this.gis.set({ title: 'Automatización de procesos' });
    // se consultan los procesos secundarios
    this.loadSecondaryProcess();
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Realiza la consulta de los procesos secundarios
   *
   * @param {number} [idSecondary]
   * @memberof ManagementAutomationComponent
   */
  loadSecondaryProcess(idSecondary?: number) {
    if (idSecondary) {
      this.idSecondaryProcessSelect = idSecondary;
    }
    this.mads.getProcessSecondarys().subscribe(process => {
      this.secondaryProcess = process;
      if (this.idSecondaryProcessSelect) {
        this.selectSecondaryProcess();
      }
    });
  }

  /**
   * Valida la información de los selects y guía el comportamiento
   * del usuario bloqueando y desapareciendo opciones.
   *
   * @param {Action} action
   * @returns {Partial<ConfigShowItems>}
   * @memberof ManagementAutomationComponent
   */
  cptShowItems(action: Action, typeProcess: TypeProcess = 'process'): Partial<ConfigShowItems> {
    const show: Partial<ConfigShowItems> = {};
    switch (typeProcess) {
      case 'process':
        switch (action) {
          case 'create':
            show.process = !this.stcRef.category ? false : true;
            show.tramite = !this.stcRef.process ? false : true;
            show.secondaryProcess = false;
            break;
          case 'edit':
            show.category = !this.stcRef.category ? false : true;
            show.process = !this.stcRef.process ? false : true;
            show.tramite = !this.stcRef.tramite ? false : true;
            show.secondaryProcess = false;
            break;
          case 'delete':
            show.category = !this.stcRef.category || !isEmpty(this.stcRef.processes) ? false : true;
            show.process = !this.stcRef.process || !isEmpty(this.stcRef.tramites) ? false : true;
            show.tramite = !this.stcRef.tramite ? false : true;
            show.secondaryProcess = false;
            break;
        }
        break;
      case 'secondary_process':
        switch (action) {
          case 'create':
            show.category = false;
            show.process = false;
            show.tramite = false;
            show.secondaryProcess = true;
            break;
          case 'edit':
            show.category = false;
            show.process = false;
            show.tramite = false;
            show.secondaryProcess = this.secondaryProcessSelect ? true : false;
            break;
          case 'delete':
            show.category = false;
            show.process = false;
            show.tramite = false;
            show.secondaryProcess = this.secondaryProcessSelect ? true : false;
            break;
        }
        break;
    }
    return show;
  }

  /**
   * Controla el objeto seleccionado en el selector de secundarias
   *
   * @param {number} id
   * @memberof ManagementAutomationComponent
   */
  selectSecondaryProcess() {
    const secondary = find(this.secondaryProcess, {id: this.idSecondaryProcessSelect});
    if (secondary) {
      this.secondaryProcessSelect = secondary;
    } else {
      this.secondaryProcessSelect = undefined;
      this.idSecondaryProcessSelect = undefined;
    }
  }

  /**
   * Abrir modal de titulos del proceso
   *
   * @memberof ManagementAutomationComponent
   */
  openModalTitles() {
    if (this.stcRef.tramite.id) {
      this.modalRef = this.modalService.show(
        this.manageTitles,
        { class: 'modal-lg-personalized', ignoreBackdropClick: true }
      );
    } else {
      this.toastr.warning('Debe seleccionar un trámite', 'Acción no permitida');
    }
  }

  /**
   *Abre la modal de configuración de anulación
   *
   * @memberof ManagementAutomationComponent
   */
  openModalAnnulation(){
    if (this.stcRef.tramite.id) {
      this.modalRef = this.modalService.show(
        this.manageAnnulation,
        { class: 'modal-lg-personalized', ignoreBackdropClick: true }
      );
    } else {
      this.toastr.warning('Debe seleccionar un trámite', 'Acción no permitida');
    }
  }

  /**
   * Cerrar modal de titulos del proceso
   *
   * @memberof ManagementAutomationComponent
   */
  closeModalTitles() {
    this.modalRef.hide();
    this.modalRef = null;
  }

  /**
   *Cerrar la modal de anulación
   *
   * @memberof ManagementAutomationComponent
   */
  closeModalAnnulation(){
    this.modalRef.hide();
    this.modalRef = null;
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/management-automation/management-automation.component.ts